<template>
    <div class="modalBackground">
        <div class="ModalForm">
            <div class="header">
                <h1 class="Title">Campaign Codes</h1>
                <div class="Options">
                    <button @click.stop="close">Close</button>
                </div>
            </div>
            <div class="modalBody" v-if="selectedCampaign !== null">
                <div class="row">
                    <h2 style="margin: 0px 0px;">Campaign Details</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Campaign Name</th>
                                <th>Trial Days</th>
                                <th>Card Required</th>
                                <th>Discount (%)</th>
                                <th>Amount Discount</th>
                                <th>Single Used</th>
                                <th>Expired Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ selectedCampaign.campaignName }}</td>
                                <td>{{ selectedCampaign.trialDays }}</td>
                                <td>{{ selectedCampaign.isCardRequired }}</td>
                                <td>{{ selectedCampaign.discount }}</td>
                                <td>{{ selectedCampaign.amountDiscount }}</td>
                                <td>{{ selectedCampaign.isSingleUsed }}</td>
                                <td>{{ displayDate(selectedCampaign.expiredDate) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="row">
                    <h2 style="margin-bottom: 0px;">Generate a number of trial codes </h2>
                    <table>
                        <tbody>
                            <tr>
                                <td style="width:210px;">Campaign prefix</td>
                                <td><input type="text" v-model="prefix" maxlength="25" /></td>
                            </tr>
                            <tr>
                                <td>Number of code to generate</td>
                                <td><input type="number" v-model.number="numberOfCodes" min="0" /></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    <button @click="GenerateCodes">Generate Code</button>
                                    <button class="codeButtons" @click="resetCodes">Reset</button>
                                </td>
                            </tr>
                            <tr v-if="prefixNumbers !== null && prefixNumbers.length > 0">
                                <td colspan="3">
                                    <div class="row codeTableContainer">
                                        <h2>Trial Code Collection</h2>
                                        <table class="codeTable">
                                            <tbody>
                                                <tr v-for="(code, index) in prefixNumbers" :key="index">
                                                    <td style="text-align:center;width:50px">{{index + 1}}</td>
                                                    <td>{{ code }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="prefixNumbers !== null && prefixNumbers.length > 0">
                                <td></td>
                                <td><button @click="saveTrialCodes">Save Trial Codes</button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="row">
                    <div class="header-row">
                        <h2 style="margin-bottom: 0px;">Campaign trial codes</h2>
                        <div class="showTitles">
                            <button class="generate-button" @click="GenerateStripeCodes(selectedCampaign.id)" v-if="shouldShowGenerateButton">Generate code for Stripe</button>
                            <button class="generate-button" @click="exportToCSV(selectedCampaign.id)" v-if="campaigncodes !== null && campaigncodes.length > 0">Export to CSV</button>
                            <button class="generate-button" @click="deleteAllCampaignCodes(selectedCampaign.id)" v-if="campaigncodes !== null && campaigncodes.length > 0">Delete All</button>
                        </div>
                    </div>
                    <div class="total-codes-row" v-if="campaigncodes !== null && campaigncodes.length > 0"><label> Total Codes : {{campaigncodes !== null ? campaigncodes.length : '0'}} </label></div>
                    <div class="scrollable-container">
                        <table class="CampaignCodeTable">
                            <thead>
                                <tr>
                                    <th style="width:20px;">&nbsp;</th>
                                    <th>Trial code</th>
                                    <th style="width:230px;">Is code created in Stripe?</th>
                                    <th>Redemptions</th>
                                    <th style="width:80px;">Options</th>
                                </tr>
                            </thead>
                            <tbody v-for="(campaignCode, index) in campaigncodes" :key="campaignCode.id">
                                <tr>
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <input v-if="editingIndex === index" v-model="campaignCode.code">
                                        <span v-else>{{ campaignCode.code }}</span>
                                    </td>
                                    <td>{{ campaignCode.stripePromoCodeID ? 'Yes' : 'No' }}</td>
                                    <td>{{ campaignCode.redemptions }}</td>
                                    <td class="Options">
                                        <button v-if="(campaignCode.stripePromoCodeID === '' || campaignCode.stripePromoCodeID === null) && !isEditing(index)" @click="editRow(index)">Edit</button>
                                        <button v-if="isEditing(index)" @click="saveEditTrialCodes(index,campaignCode.id,campaignCode.code)">Save</button>
                                        <button v-if="isEditing(index)" @click="cancelEdit">Cancel</button>
                                        <button v-if="(campaignCode.stripePromoCodeID === '' || campaignCode.stripePromoCodeID === null) && !isEditing(index)" class="destructive" @click="deleteCampaignCode(campaignCode.id)">Delete</button>
                                    </td>
                                </tr>
                                <tr v-if="campaignCode.CodeUsedList && campaignCode.CodeUsedList.length > 0">
                                    <td></td>
                                    <td colspan="4">
                                        <table class="InnerTable">
                                            <thead>
                                                <tr>
                                                    <th width="120">Code used date</th>
                                                    <th>Email</th>
                                                    <th>Company</th>
                                                    <th>Name</th>
                                                    <th v-if="campaignCode.CodeUsedList && campaignCode.CodeUsedList.some(user => user.unipassNumber)">Unipass Number</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(camCodeUsed) in campaignCode.CodeUsedList" :key="camCodeUsed.id">
                                                    <td>{{ displayDate(camCodeUsed.codeUsedDate) }}</td>
                                                    <td>{{ camCodeUsed.usedBy }}</td>
                                                    <td>{{ camCodeUsed.userCompany }}</td>
                                                    <td>{{ camCodeUsed.unipassFullName != null ? camCodeUsed.unipassFullName : '' }}</td>
                                                    <td v-if="camCodeUsed.unipassNumber">{{ camCodeUsed.unipassNumber != null ? camCodeUsed.unipassNumber : '' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-if="!campaigncodes || campaigncodes.length === 0">
                                <tr>
                                    <td colspan="5">
                                        <p>No campaign codes available.</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .UlCodes {
        margin: 0px;
    }

    .LiCodes {
        padding: 2px 0px;
    }

    .header-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
    }

        .header-row h2 {
            margin-right: 10px;
        }

    .total-codes-row {
        text-align: right;
    }

    .showTitles {
        display: flex;
    }

    .generate-button {
        margin-left: 10px;
    }

    .codeButtons {
        margin-left: 2px;
    }

    .codeTableContainer {
        max-height: 300px;
        overflow-y: auto;
    }

    .codeTable {
        width: 85%;
    }

    .scrollable-container {
        max-height: 470px;
        overflow-y: auto;
    }

    .CampaignCodeTable {
        width: 100%;
    }

    table th {
        padding: 6px 8px;
    }
</style>

<script>
    import $ from 'jquery';

    export default {
        name: 'CampaignCodes',
        components: {
        },
        data: function () {
            return {
                prefix: '',
                numberOfCodes: 0,
                loading: false,
                prefixNumbers: [],
                editingIndex: -1,
                originalCode: null,
            }
        },
        props: {
            campaigncodes: {
                type: Array,
                default: () => [],
            },
            selectedCampaign: {
                type: Object,
                default: () => [],
            },
            iscampaigncodeslist: Boolean
        },
        computed: {
            shouldShowGenerateButton() {
                return this.campaigncodes !== null && this.campaigncodes.length > 0 && this.selectedCampaign.stripeCouponId;
            }
        },
        watch: {
            campaigncodes: {
                immediate: true,
                handler(newCampaignCodes) {
                    if (Array.isArray(newCampaignCodes) && newCampaignCodes.length > 0) {
                        this.initializeCampaignCodes();
                    }
                }
            }
        },
        methods: {
            async initializeCampaignCodes() {
                if (!this.campaigncodes || this.campaigncodes.length === 0) return;

                this.loading = true;
                try {
                    if (!this._campaignCodesFetched) {
                        this._campaignCodesFetched = true;

                        const response = await $.ajax({
                            type: 'GET',
                            url: `/Campaign/GetCampaignCodeUsed`,
                            dataType: 'json'
                        });

                        if (response != null) {
                            this.campaigncodes = this.campaigncodes.map(res => ({
                                ...res,
                                CodeUsedList: response.filter(code => code.campaignCodeID === res.id) || [],
                            }));
                        }
                    }
                } catch (error) {
                    console.error("Error fetching campaign code used list:", error);
                } finally {
                    this.loading = false;
                }
            },
            displayDate: function (d) {
                if (d === null)
                    return "-";
                return d.substr(8, 2) + "/" + d.substr(5, 2) + "/" + d.substr(0, 4);
            },
            close() {
                this.$emit('close-modal');
            },
            deleteCampaignCode(id) {
                var vm = this;
                if (confirm("Are you sure you want to delete this campaign code?")) {
                    $.ajax({
                        type: 'DELETE',
                        url: `/Campaign/DeleteCampaignCode/${id}`,
                        success: function (response) {
                            vm.$emit('campaignCodesUpdated', response);
                        },
                        error: function (xhr) {
                            if (xhr.status === 404)
                                alert("Campaign code not found.");
                            else if (xhr.status === 500)
                                alert("An internal server error occurred.");
                            else
                                alert('Error deleting campaign code:', + xhr.responseText);
                        }
                    });
                }
            },
            getCampaignCodeList() {
                return new Promise((resolve, reject) => {
                    $.ajax({
                        type: 'GET',
                        url: `/Campaign/GetCampaignCodeList`,
                        dataType: 'json',
                        success: data => {
                            resolve(data);
                        },
                        error: error => {
                            reject(error);
                        }
                    });
                });
            },
            GenerateCodes() {
                if (!this.prefix.trim() || !this.numberOfCodes) {
                    if (!this.prefix.trim() && !this.numberOfCodes) {
                        alert('Please enter a prefix and number of codes before generating codes.');
                    } else if (!this.prefix.trim()) {
                        alert('Please enter a prefix before generating codes.');
                    } else {
                        alert('Please enter number of codes before generating codes.');
                    }
                    return;
                }

                this.getCampaignCodeList().then(dbCampaignTrailCodes => {
                    const prefix = this.prefix.trim();
                    const numberOfCodes = this.numberOfCodes;
                    this.prefixNumbers = this.GetRandomNumberList(prefix, numberOfCodes, dbCampaignTrailCodes);
                }).catch(() => {
                    alert('Failed to fetch campaign codes');
                });
            },
            GetRandomNumberList(prefix, numbers, dbCampaignTrailCodes) {
                const randomNumberList = new Set();

                while (randomNumberList.size < numbers) {
                    const intValue = Math.floor(Math.random() * 90000) + 10000;
                    const newCode = prefix + intValue.toString();

                    if (!dbCampaignTrailCodes.includes(newCode))
                        randomNumberList.add(newCode);
                }
                return Array.from(randomNumberList);
            },
            saveTrialCodes() {
                if (!this.selectedCampaign || !this.selectedCampaign.id) {
                    alert('Selected campaign is invalid.');
                    return;
                }
                if (!this.prefix || !this.numberOfCodes) {
                    alert('Prefix or number of codes is missing.');
                    return;
                }
                const requestData = {
                    campaignCodeId: this.selectedCampaign.id,
                    codes: this.prefixNumbers
                };
                $.ajax({
                    type: 'POST',
                    url: '/Campaign/SaveTrialCodes',
                    contentType: 'application/json',
                    data: JSON.stringify(requestData),
                    success: (data) => {
                        if (data) {
                            this.$emit('trial-codes-saved', data);
                            alert('Trial codes saved successfully');
                            this.resetCodes();
                        } else {
                            alert('No trial codes were saved.');
                        }
                    },
                    error: (xhr) => {
                        if (xhr.responseJSON && xhr.responseJSON.detail) {
                            alert(xhr.responseJSON.detail);
                        } else {
                            alert('An error occurred while saving trial codes. Please try again.');
                        }
                    }
                });
            },
            resetCodes() {
                this.prefix = '';
                this.numberOfCodes = 0;
                this.prefixNumbers = null;
            },
            isEditing(index) {
                return this.editingIndex === index;
            },
            editRow(index) {
                this.originalCode = this.campaigncodes[index].code;
                this.editingIndex = index;
            },
            cancelEdit() {
                this.campaigncodes[this.editingIndex].code = this.originalCode;
                this.editingIndex = -1;
            },
            saveEditTrialCodes(index, id, code) {
                this.editingIndex = -1;
                const originalCode = this.originalCode;
                if (!code) {
                    alert('Campaign code is require.');
                    this.campaigncodes[index].code = originalCode;
                    return false;
                }
                const data = {
                    ID: id,
                    Code: code,
                };
                $.ajax({
                    type: 'POST',
                    url: `/Campaign/SaveEditTrialCodes`,
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    success: (response) => {
                        if (response.status === 200) {
                            alert(response.message);
                        }
                        this.editingIndex = -1;
                    },
                    error: (xhr) => {
                        try {
                            if (xhr.status === 400) {
                                alert(xhr.responseText);
                            } else if (xhr.status === 404) {
                                alert('Trial code not found.');
                            } else if (xhr.status === 500) {
                                alert('An internal server error occurred.');
                            } else {
                                alert('Unknown error occurred.');
                            }
                            this.editingIndex = -1;
                            this.campaigncodes[index].code = originalCode;
                        } catch (e) {
                            alert('An error occurred during updating campaign code:', e);
                        }
                        return false;
                    }
                });
            },
            GenerateStripeCodes(id) {
                $.ajax({
                    type: 'POST',
                    url: `/Campaign/GenerateStripeCode/${id}`,
                    contentType: 'application/json',
                    success: (response) => {
                        if (response === "No pending promo codes to generate.") {
                            alert(response);
                        } else {
                            this.$emit('campaignCodesUpdated', response);
                            alert("Stripe codes generated successfully.");
                        }
                    },
                    error: (xhr) => {
                        if (xhr.status === 400) {
                            alert('Campaign does not have a Stripe coupon associated with it.');
                        } else if (xhr.status === 404) {
                            alert('Campaign not found.');
                        } else if (xhr.status === 500) {
                            alert('An internal server error occurred.');
                        } else {
                            alert('An error occurred while generating Stripe codes. Please try again.');
                        }
                    }
                });
            },
            exportToCSV(campaignId) {
                window.location.href = `/Campaign/ExportToCSV/${campaignId}`;

                setTimeout(function () {
                    alert('Codes exported to CSV successfully!');
                }, 500);
            },
            deleteAllCampaignCodes(campaignId) {
                if (confirm("Are you sure you want to delete all campaign codes?")) {
                    $.ajax({
                        type: 'DELETE',
                        url: `/Campaign/DeleteAllCampaignCodes/${campaignId}`,
                        success: (response) => {
                            this.$emit('campaignCodesUpdated', response);
                        },
                        error: (xhr) => {
                            if (xhr.status === 404) {
                                alert("No campaign codes found for the specified campaign.");
                            } else if (xhr.status === 500) {
                                alert("An error occurred while deleting campaign codes.");
                            } else {
                                alert('Failed to delete campaign codes.');
                            }
                        }
                    });
                }
            }
        },
    };
</script>